export default __webpack_public_path__ + "static/media/edge.383401f7.svg";